module.exports = __webpack_public_path__ + "img/tmkk_gomb_aktiv.7c69c91f.png";